export default __webpack_public_path__ + "293cfa07132b3084ef5979369995379c.jpg";